import {Fill, Icon, Stroke, Style, Text} from "ol/style";
import Circle from "ol/style/Circle";
import {config} from "../../config";
import {toUpper} from "lodash";

export const inventoryLocationStyle = (feature, overflow = null) => {
    let fill = new Fill({color: 'rgba(0, 200, 255, 0.1)'});
    let strokeColor = 'rgb(0, 200, 255)';

    if(/edit\/locations.*?\/(add|edit)/.test(window.location.href) && !feature.get('edited')) {
        fill = new Fill({color: 'rgb(91,136,145,0.1)'});
        strokeColor = 'rgb(91,136,145)';
    }

    return new Style({
        stroke: new Stroke({
            color: strokeColor,
            width: 2,
        }),
        fill,
        text: new Text({
            textAlign: 'center',
            textBaseline: 'middle',
            text: feature.get('name'),
            fill: new Fill({color: 'white'}),
            stroke: new Stroke({color: 'rgb(0, 200, 255)', width: 1}),
            backgroundFill: new Fill({color: 'rgba(0, 0, 0, 0.1)'}),
            placement: 'point',
            font: '14px sans-serif',
            overflow: overflow === false ? false : 'overflow',
        }),
    });
}

export const groupHuntingLocationObserversLineStyle = (feature, overflow = null) => {
    return new Style({
        image: new Icon({
            src: `${config('app.base_path')}/images/selected-device-type-9.png`,
            anchor: [0.5, 1],
            scale: 1,
            size: [20, 23]
        }),
        stroke: new Stroke({
            color: 'rgb(26,255,0)',
            width: 2,
        }),
        fill: new Fill({ color: 'rgba(6,82,0,0.71)' }),
        text: new Text({
            textAlign: 'center',
            textBaseline: 'middle',
            text: feature.get('name'),
            fill: new Fill({ color: 'white' }),
            stroke: new Stroke({ color: 'rgb(19,73,0)', width: 2 }),
            backgroundFill: new Fill({ color: 'rgba(0, 0, 0, 0.1)' }),
            placement: 'point',
            font: '14px sans-serif',
            overflow: overflow === false ? false : 'overflow',
        }),
    });
};

export const inventoryLocationObserversLineStyle = (feature, overflow = null) => {
    return new Style({
        image: new Circle({
            fill: new Fill({
                color: 'rgb(26,255,0, 0.6)'
            }),
            stroke: new Stroke({
                color: 'rgba(38,171,5,0.8)'
            }),
            radius: 7
        }),
        stroke: new Stroke({
            color: 'rgb(26,255,0)',
            width: 2,
        }),
        fill: new Fill({color: 'rgba(6,82,0,0.71)'}),
        text: new Text({
            textAlign: 'center',
            textBaseline: 'middle',
            text: feature.get('name'),
            fill: new Fill({color: 'white'}),
            stroke: new Stroke({color: 'rgb(19,73,0)', width: 2}),
            backgroundFill: new Fill({color: 'rgba(0, 0, 0, 0.1)'}),
            placement: 'point',
            font: '14px sans-serif',
            overflow: overflow === false ? false : 'overflow',
        }),
    });
}

export const inventoryLocationBeatersLineStyle = (feature, overflow = null) => {
    return new Style({
        image: new Circle({
            fill: new Fill({
                color: 'rgba(255,152,0,0.6)'
            }),
            stroke: new Stroke({
                color: 'rgb(206,117,0)'
            }),
            radius: 8
        }),
        stroke: new Stroke({
            color: 'rgb(255,128,0)',
            width: 2,
        }),
        fill: new Fill({color: 'rgba(82,41,0,0.71)'}),
        text: new Text({
            textAlign: 'center',
            textBaseline: 'middle',
            text: feature.get('name'),
            fill: new Fill({color: 'white'}),
            stroke: new Stroke({color: 'rgb(80,45,0)', width: 2}),
            backgroundFill: new Fill({color: 'rgba(0, 0, 0, 0.1)'}),
            placement: 'point',
            font: '14px sans-serif',
            overflow: overflow === false ? false : 'overflow',
        }),
    });
}

export const farInventoryLocationStyle = () => {
    return new Style({
        stroke: new Stroke({
            color: 'rgb(0, 200, 255)',
            width: 2,
        }),
    })
}

export const drawInventoryLocationStyle = new Style({
    image: new Circle({
        fill: new Fill({
            color: 'rgb(255,207,34)'
        }),
        stroke: new Stroke({
            color: 'rgb(178,156,0)',
            width: 3
        }),
        radius: 5
    }),
    stroke: new Stroke({
        color: '#ffd300',
        width: 3
    }),
    fill: new Fill({
        color: 'rgba(255,231,0,0.23)'
    })
});

export const inventoryLocationPointStyle = (feature, overflow = null) => {
    return new Style({
        image: new Icon({
            src: `${config('app.base_path')}/images/location-point.png`,
            anchor: [0.5, 1],
            scale: [0.2, 0.2],
        }),
        text: new Text({
            textAlign: 'center',
            textBaseline: 'middle',
            text: feature.get('name'),
            offsetY: 12,
            fill: new Fill({color: 'white'}),
            stroke: new Stroke({color: 'rgb(0, 0, 0)', width: 2}),
            // backgroundFill: new Fill({color: 'rgba(0, 0, 0, 0.1)'}),
            placement: 'point',
            font: '14px sans-serif',
            overflow: overflow === false ? false : 'overflow',
        }),
    });
}

export const inventoryLocationHunterPointStyle = (feature, overflow = null) => {
    return new Style({
        image: new Icon({
            src: `${config('app.base_path')}/images/hunter-point.png`,
            anchor: [0.5, 1],
            scale: [0.2, 0.2],
        }),
        text: new Text({
            textAlign: 'center',
            textBaseline: 'middle',
            text: feature.get('name'),
            offsetY: 12,
            fill: new Fill({color: 'white'}),
            stroke: new Stroke({color: 'rgb(0, 0, 0)', width: 2}),
            // backgroundFill: new Fill({color: 'rgba(0, 0, 0, 0.1)'}),
            placement: 'point',
            font: '14px sans-serif',
            overflow: overflow === false ? false : 'overflow',
        }),
    });
}

export const farInventoryLocationPointStyle = () => {
    return new Style({
        image: new Icon({
            src: `${config('app.base_path')}/images/location-point.png`,
            anchor: [0.5, 1],
            scale: [0.08, 0.08],
        }),
    });
}

export const farInventoryLocationHunterPointStyle = () => {
    return new Style({
        image: new Icon({
            src: `${config('app.base_path')}/images/hunter-point.png`,
            anchor: [0.5, 1],
            scale: [0.08, 0.08],
        }),
    });
}

export const inventoryLocationThermalImagingTransectsLineStyle = (feature, overflow = null) => {
    return new Style({
        image: new Circle({
            fill: new Fill({
                color: 'rgba(255,0,221,0.6)'
            }),
            stroke: new Stroke({
                color: 'rgb(168,0,206)'
            }),
            radius: 4
        }),
        stroke: new Stroke({
            color: 'rgb(148,0,208)',
            width: 3,
        }),
        fill: new Fill({color: 'rgba(82,41,0,0.71)'}),
    });
}

export const inventoryLocationThermalImagingTransectsFeatureStyle = (feature) => {
    let side = 'LEFT';
    if(feature.get('side') && toUpper(feature.get('side')) === 'RIGHT') {
        side = 'RIGHT';
    }

    return new Style({
        stroke: new Stroke({
            color: side === 'LEFT' ? 'rgb(255,29,253)' : 'rgb(0,30,183)',
            width: 2,
        }),
        fill: new Fill({color: side === 'LEFT' ? 'rgba(255,29,253,0.2)' : 'rgba(0,30,183,0.2)'}),
    });
}

export const inventoryLocationThermalImagingRoutesStyle = (feature, overflow = null) => {
    return [
        new Style({
            stroke: new Stroke({
                color: 'rgba(154,0,255,0.85)',
                width: 4,
            }),
        }),
        new Style({
            stroke: new Stroke({
                color: 'rgba(216,176,241,0.85)',
                width: 1,
            }),
        })
    ]
}